import Vue from "vue";
import Router from "vue-router";

// Login
import Login from "@/components/Login/Login";

// Home
import Home from "@/pages/Home";

// Cloud admin
import CloudAdmin from "@/pages/CloudAdmin";
import adminUsers from "@/components/CloudAdmin/users";
import adminLevesl from "@/components/CloudAdmin/levels";
import adminProjects from "@/components/CloudAdmin/projects";

import adminUserForm from "@/components/CloudAdmin/forms/user";
import adminProjectForm from "@/components/CloudAdmin/forms/project";

// auditoria
import auditoria from "@/pages/Auditoria";
import audiTirmeAcessUserHistoty from "@/components/auditoria/accessUserhistory";
import audiTirmeAcessDateHistoty from "@/components/auditoria/accessDatehistory";
import audiTirmeAcessDateHistotyResumen from "@/components/auditoria/accessDatehistoryResumen";

import audiTirmeAcessHistotyUser from "@/components/auditoria/accesshistory/user";
import audiTirmeAcessHistotyDate from "@/components/auditoria/accesshistory/date";

import audiTirmeUsersnotifications from "@/components/auditoria/userNotificactions";
import audiTirmeUsernotifications from "@/components/auditoria/notifications/user";

import audiTirmenotificationsAgrupadas from "@/components/auditoria/userNotificactionsAgrupadas";
import audiTirmenotificationAgrupada from "@/components/auditoria/notifications/user";

import audiTirmeNotificationUsers from "@/components/auditoria/notificactionUsers";
import audiTirmeAcessDocumentHistotyResumen from "@/components/auditoria/accessDocumenthistory";

// Dashboard
import Dashboard from "@/pages/Dashboard";
import icons from "@/pages/icons";

import Content from "@/components/Dashboard/Content";
import List from "@/components/Dashboard/List";
import MontarFormulario from "@/components/Dashboard/MontarFormulario";
import Bread from "@/components/Dashboard/Bread";
import editForm from "@/components/Dashboard/editForm";

import Pages from "@/components/Dashboard/pages/list";
import FormPage from "@/components/Dashboard/pages/form";
import SecTionPage from "@/components/Dashboard/pages/seccion";

import homepage from "@/components/Dashboard/home/list";
import FormNewDesktopHome from "@/components/Dashboard/home/form";

import Usuarios from "@/components/Dashboard/usuarios";
import FormUsuario from "@/components/Dashboard/forms/formUsuarios";
import RecoveryPass from "@/components/login/recoverypass";

// Plugin nomina
import Nominas from "@/components/Dashboard/nominas/list";
import NominasForm from "@/components/Dashboard/nominas/form";

// Plugin justificacion nomina
import JustificacionNominas from "@/components/Dashboard/justificacion_nominas/list";
import  JustificacionNominasForm from "@/components/Dashboard/justificacion_nominas/form";

// Plugin justificacion nomina
import ProveedoresList from "@/components/Dashboard/proveedores/list";


// Plugin notificaciones cron
import NotificacionesList from "@/components/Dashboard/notificaciones_cron/list";
import NotificacionesForm from "@/components/Dashboard/notificaciones_cron/form";

// Plugin envios
import EnviosList from "@/components/Dashboard/plugins/envios/list";
import EnviosForm from "@/components/Dashboard/plugins/envios/form";

// Plugin mis documentos
import MisDocumentosList from "@/components/Dashboard/plugins/misdocumentos/list";
import MisDocumentosForm from "@/components/Dashboard/plugins/misdocumentos/form";

// Plugin avisos
import avisosList from "@/components/Dashboard/plugins/avisos/list";
import avisosEdit from "@/components/Dashboard/plugins/avisos/form";
import avisosEnviosList from "@/components/Dashboard/plugins/avisos/envios_list";



Vue.use(Router);

export default new Router({
    mode: "history",
    cors: true,
    routes: [
        {
            path: "/",
            name: "Home",
            component: Login
        },
        {
            path: "/login",
            name: "Login",
            component: Login
        },
        {
            path: "/recovery-pass",
            name: "RecoveryPass",
            component: RecoveryPass,
            children: [
                {
                    path: ":token",
                    name: "Restablecer contraseña",
                    component: RecoveryPass
                }
            ]
        },
        {
            path: "/home",
            name: "Pre-dashboard",
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/admin",
            name: "CloudAdmin",
            component: CloudAdmin,
            children: [
                {
                    path: "levels",
                    name: "CloudAdmin levels",
                    component: adminLevesl
                },
                {
                    path: "projects",
                    name: "CloudAdmin projects",
                    component: adminProjects
                },
                {
                    path: "users",
                    name: "CloudAdmin users",
                    component: adminUsers
                },
                {
                    path: "users/new",
                    name: "Add new user",
                    component: adminUserForm
                },
                {
                    path: "users/edit/:user_id",
                    name: "Edit user",
                    component: adminUserForm
                },
                {
                    path: "projects/new",
                    name: "Add new project",
                    component: adminProjectForm
                },
                {
                    path: "projects/edit/:project_id",
                    name: "Edit project",
                    component: adminProjectForm
                }
            ],
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/auditoria",
            name: "auditoria",
            component: auditoria,
            children: [
                {
                    path: "access-history-user",
                    name: "auditoria access users history",
                    component: audiTirmeAcessUserHistoty
                },
                {
                    path: "access-history/user-history/:user_id",
                    name: "auditoria user access history by user",
                    component: audiTirmeAcessHistotyUser
                },
                {
                    path: "access-history-date",
                    name: "auditoria access date history",
                    component: audiTirmeAcessDateHistoty
                },
                {
                    path: "access-history/date-history/:date",
                    name: "auditoria user access history by date",
                    component: audiTirmeAcessHistotyDate
                },
                {
                    path: "user-notifications",
                    name: "auditoria users notification",
                    component: audiTirmeUsersnotifications
                },
                {
                    path: "user-notifications/user/:user",
                    name: "auditoria user notifications",
                    component: audiTirmeUsernotifications
                },
                {
                    path: "notifications-agrupadas",
                    name: "auditoria notificationes agrupadas",
                    component: audiTirmenotificationsAgrupadas
                },
                {
                    path: "notifications-agrupadas/notificacion/:notificacion",
                    name: "auditoria notificaciones agrupadas",
                    component: audiTirmenotificationAgrupada
                },
                {
                    path: "notification-users",
                    name: "auditoria notifications users",
                    component: audiTirmeNotificationUsers
                },
                {
                    path: "access-history-resumen",
                    name: "auditoria access date resumen",
                    component: audiTirmeAcessDateHistotyResumen
                },
                {
                    path: "access-history-documents",
                    name: "auditoria access documento",
                    component: audiTirmeAcessDocumentHistotyResumen
                }
            ],
            meta: {
                requiresAuth: true
            }
        },
        {
            path: "/dashboard",
            name: "Dashboard",
            component: Dashboard,
            children: [
                {
                    path: ":db",
                    name: "Dashboard-panel",
                    component: Content,
                    children: [
                        {
                            path: "notificaciones_periodicas",
                            name: "Listado de notificaciones",
                            component: NotificacionesList
                        },
                        {
                            path: "notificaciones_periodicas/edit/:id",
                            name: "Notificaciones editar ",
                            component: NotificacionesForm
                        },
                        {
                            path: "notificaciones_periodicas/new",
                            name: "Notificaciones nueva notificacion",
                            component: NotificacionesForm
                        },
                        {
                            path: "nomina",
                            name: "Listado de Nominas",
                            component: Nominas
                        },
                        {
                            path: "nomina/edit/:id",
                            name: "Nominas editar ",
                            component: NominasForm
                        },
                        {
                            path: "nomina/new",
                            name: "Nominas nueva nomina",
                            component: NominasForm
                        },
                        {
                            path: "justificacion_nominas",
                            name: "Listado de Justificacion Nomins",
                            component: JustificacionNominas
                        },
                        {
                            path: "justificacion_nominas/edit/:id",
                            name: "Justificacion Nominas editar ",
                            component: JustificacionNominasForm
                        },
                        {
                            path: "justificacion_nominas/new",
                            name: "Justificacion Nominas nueva nomina",
                            component: JustificacionNominasForm
                        },
                        {
                            path: "proveedores",
                            name: "Listado de Proveedores",
                            component:ProveedoresList
                        },
                        {
                            path: "envios",
                            name: "Listado de envíos",
                            component: EnviosList
                        },
                        {
                            path: "envios/edit/:id",
                            name: "Envíos editar ",
                            component: EnviosForm
                        },
                        {
                            path: "envios/new",
                            name: "Envíos nuevo envio",
                            component: EnviosForm
                        },
                        {
                            path: "misdocumentos",
                            name: "Listado de envíos",
                            component: MisDocumentosList
                        },
                        {
                            path: "misdocumentos/edit/:id",
                            name: "Envíos editar ",
                            component: MisDocumentosForm
                        },
                        {
                            path: "misdocumentos/new",
                            name: "Envíos nuevo envio",
                            component: MisDocumentosForm
                        },
                        {
                            path: "home-page",
                            name: "Dashboard Página home",
                            component: homepage
                        },
                        {
                            path:
                                "home-page/edit/:id/notification/:template_id/:notification_id",
                            name: "Dashboard editar notificacion",
                            component: FormNewDesktopHome
                        },
                        {
                            path: "home-page/edit/:id",
                            name: "Dashboard editar página",
                            component: FormNewDesktopHome
                        },
                        {
                            path: "home-page/new",
                            name: "Dashboard nuevo escritorio en página home",
                            component: FormNewDesktopHome
                        },
                        {
                            path: "pages",
                            name: "Dashboard Páginas",
                            component: Pages
                        },
                        {
                            path: "pages/edit/:id",
                            name: "Dashboard editar escritorio home página",
                            component: FormPage
                        },
                        {
                            path: "pages/new",
                            name: "Dashboard nueva página",
                            component: FormPage
                        },
                        {
                            path: "pages/seccion",
                            name: "Dashboard página - sección",
                            component: SecTionPage
                        },
                        {
                            path:
                                "pages/:page/seccion/:section_id/content/:content_id/:template_id",
                            name:
                                "Dashboard página - sección - edición - contenido",
                            component: SecTionPage
                        },
                        {
                            path: "pages/:page/seccion/:section_id",
                            name: "Dashboard página - sección - edición",
                            component: SecTionPage
                        },
                        {
                            path: "formularios",
                            name: "Dashboard-formularios",
                            component: MontarFormulario
                        },
                        {
                            path: "formulario/nuevo/:table",
                            name: "Dashboard formulario nuevo",
                            component: Bread
                        },
                        {
                            path: "formulario/editar/:table",
                            name: "Dashboard formulario editar",
                            component: Bread
                        },
                        {
                            path: "formulario/eliminar/:table",
                            name: "Dashboard formulario eliminar",
                            component: Bread
                        },
                        {
                            path: "usuarios",
                            name: "Dashboard Usuarios",
                            component: Usuarios
                        },
                        {
                            path: "usuarios/nuevo",
                            name: "Dashboard Nuevo Usuario",
                            component: FormUsuario
                        },
                        {
                            path: "usuarios/editar/:id",
                            name: "Dashboard Editar Usuario",
                            component: FormUsuario
                        },
                        {
                            path: "list/:table",
                            name: "Dashboard-list",
                            component: List
                        },
                        {
                            path: "form/edit/:table/:id",
                            name: "Dashboard editar registro",
                            component: editForm
                        },
                        {
                            path: "form/new/:table",
                            name: "Dashboard nuevo registro",
                            component: editForm
                        },
                        {
                            path: "icons",
                            name: "Dashboard Iconos",
                            component: icons
                        },
                        {
                            path: "plugins/avisos",
                            name: "Listado de avisos ",
                            component: avisosList
                        },
                        {
                            path: "plugins/avisos/edit/:id",
                            name: "Editar avisos ",
                            component: avisosEdit
                        },
                         {
                            path: "plugins/avisos/new",
                            name: "Nuevo Avisos ",
                            component: avisosEdit
                        },
                        {
                            path: "plugins/avisos/envios/:id",
                            name: "Listado de avisos ",
                            component: avisosEnviosList
                        },

                    ]
                }
            ],
            meta: {
                requiresAuth: true
            }
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js